import { useEffect } from "react";
import { useAppSelector } from "../../../Store";
import { ValueType } from "../../../Definitions";
import { useDispatch } from "react-redux";
import { selectAllAnimalOptions, upsertAnimalOptions } from "../../../Store/optionsHandlers/optionsCombinedReducer";
import { gql, useQuery } from "@apollo/client";
import { BasicQueryInfoInput } from "../../../Services/Agrisys_GqlDataCaller/FeedDataCalls/GQLCalls/getFeedComponentsCall";

const ANIMAL_OPTIONS_QUERY = gql`
  query AnimalOptions($domain: String!, $input: BasicQueryInfoInput!) {
    animal {
      info(domain: $domain, input: $input) {
        id: animal_id
        label: animal_number
        secondaryLabel: responder_number
      }
    }
  } 
`

interface AnimalOptionsResult {
  animal: {
    info: (ValueType & {secondaryLabel: string})[]
  }
}

export const useAnimalOptions = () => {
  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";

  const fetchTime = useAppSelector(({optionsState}) => {if ("lastFetched" in optionsState.animalOptions && typeof optionsState.animalOptions.lastFetched === "number") {return optionsState.animalOptions.lastFetched}})
  const dispatch = useDispatch();
  const reduxOptions = useAppSelector(selectAllAnimalOptions);
  const {data, loading} = useQuery<AnimalOptionsResult, {domain: string, input: BasicQueryInfoInput}>(ANIMAL_OPTIONS_QUERY, {
   skip: !!reduxOptions.length || fetchTime !== undefined || (fetchTime && (Date.now()-fetchTime > 300000)),
    fetchPolicy: "no-cache",
    variables: {
      domain: farm,
      input: {fetchAmount: 500}
    }
  })

  useEffect(() => {
    if (!loading && data && !reduxOptions.length) {
      dispatch(upsertAnimalOptions(data.animal.info.map((a) => ({ ...a, secondaryLabel: `(${a.secondaryLabel})` }))))
    }
  },[data, dispatch, loading, reduxOptions.length])

  return reduxOptions;
};
